import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CondominiumService, Condominium } from '../../services/condominium.service';

interface CondominiumMemberDTO {
  name: string;
  email: string;
}

@Component({
    selector: 'app-members',
    templateUrl: './members.component.html',
    styleUrls: ['./members.component.sass'],
    standalone: false
})
export class MembersComponent implements OnInit {
  condominium: Condominium | null = null;
  members: CondominiumMemberDTO[] = [];
  isOwner = false;

  displayedColumnsOwner: string[] = ['name', 'email'];
  displayedColumnsMember: string[] = ['name'];

  constructor(
    private route: ActivatedRoute,
    private condominiumService: CondominiumService
  ) { }

  async ngOnInit(): Promise<void> {
    const condominiumIdParam = this.route.parent.snapshot.paramMap.get('id');
    const condominiumId = condominiumIdParam ? Number(condominiumIdParam) : NaN;
    if (!isNaN(condominiumId)) {
      this.condominiumService.getCondominiumDetails(condominiumId).subscribe({
        next: (condominium) => {
          this.condominium = condominium;
        }
      });

      this.isOwner = await this.condominiumService.isCurrentUserOwnerOfCondominium(condominiumId);
      this.condominiumService.getCondominiumMembers(condominiumId).subscribe({
        next: (members) => this.members = members,
        error: (err) => console.error('Failed to load members', err)
      });
    }
  }
}


